<template>
  <v-col class="text-center text-caption" cols="12">
    &copy; {{ new Date().getFullYear() }} Upstate Coin &amp; Gold. All rights
    reserved - PlatformGold&reg; v{{ version }}
  </v-col>
</template>

<script>
import { version } from '../../package.json'

export default {
  data() {
    return { version }
  },
}
</script>
